import { render } from "./DashboardRefCoach.vue?vue&type=template&id=32df5c62&scoped=true"
import script from "./DashboardRefCoach.vue?vue&type=script&lang=js"
export * from "./DashboardRefCoach.vue?vue&type=script&lang=js"

import "./DashboardRefCoach.vue?vue&type=style&index=0&id=32df5c62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32df5c62"]])

export default __exports__